<template>
  <transition name="box-fade">
    <div class="sidebar-box" v-show="visible">
      <div class="sidebar-bg" v-if="showSideBg" @click="clickHide"></div>
      <transition name="slide-fade">
        <div class="side-bar" :style="`;width: ${this.width}`" v-if="visible" ref="sideBox" v-loading="loading">
          <div class="title" v-if="title">{{title}}</div>
          <div class="content-side-bar" :style="`padding:${nopadding ? '0px' : '20px 30px'}`">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'sideBar',
  props: {
    showSideBg: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean
    },
    padding: {
      type: String,
      default: '40%'
    },
    nopadding: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean
    },
    width: {
      type: String,
      default: '40%'
    }
  },
  data () {
    return {}
  },
  methods: {
    clickHide (e) {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less">
.box-fade-enter-active {
  transition: all 0.1s ease;
}
.box-fade-leave-active {
  transition: all 0.3s ease;
}
.box-fade-enter,
.box-fade-leave-to {
  opacity: 1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 1;
}
.sidebar-box {
  .sidebar-box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    z-index: 1501;
  }
  .sidebar-bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1501;
  }
  .side-bar {
    position: fixed;
    top: 0px;
    right: 0;
    width: 30%;
    max-width: 100%;
    // min-width: 346px;
    height: calc(100% - 0px);
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 10px;
    z-index: 1502;
  }
  .title {
    padding: 20px 24px;
    font-size: 20px;
    line-height: 28px;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #e9e9e9;
  }
  .title-infos,
  .title-infoss {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .title-infoss {
    margin-top: 40px;
  }
  .content-side-bar {
    padding: 20px 30px;
    max-height: calc(100vh - 10px);
    overflow-y: auto;
    overflow-x: hidden;
    .el-input,
    .el-select,
    .el-range-editor,
    .el-date-editor,
    .el-cascader {
      width: 100%;
    }
  }
}
.tags-content {
  .div-tag {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background: #f5f5f5;
    font-size: 12px;
    color: #666666;
    line-height: 20px;
    padding: 0px 8px;
  }
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #333;
}

.detail-tip {
  display: flex;
  flex: 1;
}

.detail-heading {
  flex-shrink: 0;
}

.detail-view {
  display: flex;
  flex: 1;
}

.detail-views {
  display: flex;
  flex: 3;

  .detail-remark {
    font-size: 12px;
    color: #009dc2;
    line-height: 22px;
    margin-left: 7px;
  }
}

.picture-detail-list {
  margin: 0px;
  padding: 0px;
  width: 100%;
  overflow: hidden;

  li {
    float: left;
    margin-right: 20px;
    margin-bottom: 10px;
    list-style: none;
    border: 1px solid #ddd;
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &:nth-child(4n) {
      margin-right: 0px;
    }

    &:hover {
      cursor: pointer;
    }

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/SideBar.vue